import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CookiePolicy = () => {
    return (
        <div className="bg-black min-h-screen font-sans text-gray-300 selection:bg-white selection:text-black">
            <Navbar />
            <div className="container mx-auto px-6 py-32 max-w-4xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Cookie Policy</h1>

                    <div className="space-y-8 leading-relaxed">
                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">Cosa sono i Cookie?</h2>
                            <p>
                                I cookie sono piccoli file di testo che i siti visitati dagli utenti inviano ai loro terminali, dove vengono memorizzati per essere ritrasmessi agli stessi siti in occasione di visite successive.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">Tipologia di Cookie utilizzati</h2>
                            <p>
                                Questo sito utilizza <strong>esclusivamente cookie tecnici</strong> (o assimilati), che sono essenziali per il corretto funzionamento del sito e per garantire una navigazione sicura ed efficiente.
                            </p>
                            <ul className="list-disc pl-6 mt-4 space-y-2">
                                <li><strong>Cookie di navigazione o sessione:</strong> Garantiscono la normale navigazione e fruizione del sito web.</li>
                                <li><strong>Cookie funzionali:</strong> Permettono all'utente la navigazione in funzione di una serie di criteri selezionati (ad esempio, la lingua) al fine di migliorare il servizio reso.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">Cookie di Terze Parti</h2>
                            <p>
                                Questo sito <strong>non utilizza cookie di profilazione</strong> propri nè di terze parti per inviare messaggi pubblicitari in linea con le preferenze manifestate dall'utente nell'ambito della navigazione in rete.
                                <br />
                                Eventuali video embeddati o servizi esterni sono configurati in modalità "privacy enhanced" o richiedono un consenso esplicito se dovessero tracciare l'utente.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">Gestione dei Cookie</h2>
                            <p>
                                L'utente può decidere se accettare o meno i cookie utilizzando le impostazioni del proprio browser. La disabilitazione dei cookie tecnici potrebbe compromettere l'utilizzo ottimale di alcune parti del sito.
                            </p>
                        </section>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default CookiePolicy;
